export function FeaturedPartnerBadge() {
  return (
    <span className="inline-flex rounded border border-cyan-300/50 bg-cyan-300/10 px-2 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-cyan-100 shadow-neon">
      Featured
    </span>
  );
}
